import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useAuth }from '../contexts/auth.context';
import { useNavigation } from '../contexts/navigation.context' 
import { useNavigate } from 'react-router-dom';
import { stack } from '../routes/index'
import { getModulePermissions } from '../utils/permissions';

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    padding: theme.spacing(0),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      marginLeft: +drawerWidth
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export default function DrawerMenu(props) {
    const theme = useTheme();
    const navigation = useNavigation()
    const navigate = useNavigate()
    const [open, setOpen] = React.useState(false);
    const permissions = getModulePermissions(sessionStorage.getItem('@EVAPI:permissions'))
  const { Logout, basePath } = useAuth();
    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setOpen(false);
    };
    
    React.useEffect(()=> {
      setOpen(false)
    },[])

    const SwitchScreen = (item) => {
      const isAllow = permissions[`${item.path}`]

      if (!isAllow) return;
        navigation.setPage(`/${item.path}`);
        navigation.nextPage?.(`/${item.path}`);
        navigation.setLink?.(`/${item.path}`);
        navigate(`/${item.path}`);
    }
    return (
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" open={open}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: '36px',
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div" >
              { props.title }  
            </Typography>
          </Toolbar>
        </AppBar>
        <Main open={open} sx={{width: '100%'}}>
          <DrawerHeader />
          {props.children}
        </Main>
        <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth
          }
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <Typography>Menu</Typography>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
          <List>
            {stack.map((item, index) => (
              <ListItem selected={item.path === navigation.page} sx={!permissions[`${item.path}`] ? {display: 'none'} : null} disabled={!permissions[`${item.path}`]} button key={index} onClick={() => item.path === 'Logout' ? Logout() :  SwitchScreen(item) }>
                <ListItemIcon>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.label || item.path} />
              </ListItem>
            ))}
            {basePath === 'apeprev' && (
              <>
                <Divider />
                <ListItem
                  button
                  component="a"
                  href="https://apeprev.com.br/wp-admin/admin.php?page=compensacao-cadastros"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ListItemIcon>
                    <OpenInNewIcon />
                  </ListItemIcon>
                  <ListItemText primary="COMPREV" />
                </ListItem>
              </>
            )}
          </List>
        </Drawer>
    </Box>
    );
  }